import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  wrapper: {
    marginBottom: '20px',
  },
}));

export const usePreviewStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '10px',
    border: '1px solid #f1f1f1',
    margin: '20px 0',
    [theme.breakpoints.down('xs')]: {
      padding: '4px'
    }
  }
}));

export const useAttachmentStyles = makeStyles((theme) => ({
  wrapper: {
    width: 'calc(20% - 16px)',
    paddingTop: 'calc(20% - 16px)',
    position: 'relative',
    margin: '8px',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    overflow: 'hidden',
    '& > img': {
      width: '100%',
      height: 'auto',
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
    },
    [theme.breakpoints.down('sm')]: {
      width: 'calc(25% - 16px)',
      paddingTop: 'calc(25% - 16px)',
    },
    [theme.breakpoints.down('xs')]: {
      width: 'calc(33.3333% - 8px)',
      paddingTop: 'calc(33.3333% - 8px)',
      margin: '4px',
    },
  },
  delete: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    color: '#ffffff',
    '& > svg': {
      fontSize: '14px',
    },
  },
}));

export const useUploadStyles = makeStyles((theme) => ({
  uploadArea: {
    display: 'block',
    textAlign: 'center',
    cursor: 'pointer',
    border: '2px dashed #cccccc',
    padding: '10px',
    height: '100px',
    lineHeight: 'calc(100px - 20px)',
    borderRadius: '4px',
    color: 'rgba(0, 0, 0, 0.5)',
    fontSize: '16px',
    fontStyle: 'italic',
    '& input[type="file"]': {
      display: 'none',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
  },
  uploadAreaActive: {
    backgroundColor: '#f1f1f1',
    borderColor: theme.custom.primary,
  },
  previewsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '10px',
    border: '1px solid #f1f1f1',
    margin: '20px 0',
  },
  previewImg: {
    width: 'calc(25% - 20px)',
    paddingTop: 'calc(25% - 20px)',
    position: 'relative',
    margin: '10px',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    overflow: 'hidden',
    '& > img': {
      width: '100%',
      height: 'auto',
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
    },
    [theme.breakpoints.down('xs')]: {
      width: 'calc(33.3333% - 12px)',
      paddingTop: 'calc(33.3333% - 12px)',
      margin: '6px',
    },
  },
  previewRemove: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    color: '#ffffff',
    '& > svg': {
      fontSize: '14px',
    },
  },
  modalWrapper: {
    overflow: 'auto',
  },
  modal: {
    maxWidth: '720px',
    width: '100%',
    padding: '30px',
    backgroundColor: '#ffffff',
    margin: '70px auto 50px',
  },
  modalTitle: {
    margin: '0 0 15px',
  },
  modalActions: {
    paddingTop: '20px',
    '& button': {
      marginRight: '10px',
    },
  },
}));
